__turbopack_context__.v({
  "inputCheckBox": "form-module__suduzW__inputCheckBox",
  "inputFormCheckBox": "form-module__suduzW__inputFormCheckBox",
  "labelCheckBox": "form-module__suduzW__labelCheckBox",
  "reverseInputCheckBox": "form-module__suduzW__reverseInputCheckBox",
  "reverseStyledLabelCheckBox": "form-module__suduzW__reverseStyledLabelCheckBox",
});
